module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "admin-plus-gray-icon.edd39df5.svg";